import { useCallback } from 'react'
import { highlightElement } from '../../../utils/animation'
import { useCompanyStore } from '../../../store/company/companyStore'

interface ScrollOptions {
  behavior?: ScrollBehavior
  block?: ScrollLogicalPosition
}

export const useScrollToElement = () => {
  const { company } = useCompanyStore((state) => state)

  return useCallback(
    (elementId: string, options: ScrollOptions = {}) => {
      const { behavior = 'smooth', block = 'center' } = options

      const container = document.getElementById(elementId)
      if (!container) return

      // Scroll the container into view
      container.scrollIntoView({ behavior, block })

      // Find and highlight the title element
      const titleElement = container.querySelector('.item-title')
      if (titleElement instanceof HTMLElement) {
        highlightElement(titleElement, company.settings.primaryColor)
      }
    },
    [company.settings.primaryColor]
  )
}
